export default __webpack_public_path__ + "static/media/img-0742-romania-full-face.be5b0914.png";